
import styled, { css } from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 520px;

  @media (max-width: 950px) {
    width: unset;
  }
`

export const StyledButton = styled(Button)`
  margin-top: ${props => props.isFirstRow ? '27px' : '5px'};
`
